import { FaArrowRight, FaBrain, FaExpandAlt, FaLaptopCode, FaLock } from 'react-icons/fa';
import HeroStudent from '../../assets/MainImage/HeroStudent.png';
import Stripe from '../../assets/MainImage/stripes.svg';
import ExamTerminal from './ExamTerminal';
import { useNavigate } from "react-router-dom";
import { useContext, useEffect } from 'react';
import { UserContext } from '../../context/UserContext';
import { Calendar } from 'lucide-react';
import { motion } from 'framer-motion';
import useUserStore from "../../stores/useUserStores";

const Home = () => {
  const navigate = useNavigate();
  const {

    setuserdetail,
    setToken,
    setislogin,
    setisAdmin,
  } = useUserStore();
  const handleLogin = () => {
    navigate("/login");
  };

  const handleSmoothScroll = (e: any, href: any) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  useEffect(() => {
    setuserdetail(null);
    setToken("");
    setislogin(false);
    setisAdmin(false);
  }, []);
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-[#f9fbff] to-[#e6f0ff] min-h-screen lg:pt-[10vh]">
      <div className="fixed bottom-[12%] right-10 !z-[9999]">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{
            scale: 1,
            opacity: 1,
            transition: {
              delay: 1,
              type: "spring",
              stiffness: 300,
              damping: 10,
            },
          }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="relative"
        >
          
          {/* Pink-purple floating rings */}
          <motion.div
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.3, 0.1, 0],
              transition: {
                duration: 2,
                repeat: Infinity,
                repeatType: "loop",
              },
            }}
            className="absolute inset-0 rounded-full border-2 border-pink-400"
          />
          <motion.div
            animate={{
              scale: [1, 1.4, 1],
              opacity: [0.2, 0.05, 0],
              transition: {
                duration: 3,
                repeat: Infinity,
                repeatType: "loop",
                delay: 0.5,
              },
            }}
            className="absolute inset-0 rounded-full border-2 border-purple-400"
          />

          {/* Main button with your gradient */}
          <motion.a
            href="#contact"
            className="relative overflow-hidden bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white px-6 py-3 rounded-xl font-bold flex items-center justify-center gap-3 shadow-2xl"
            whileHover={{
              background: [
                "linear-gradient(to right, #ec4899, #a855f7)",
                "linear-gradient(to right, #a855f7, #ec4899)",
                "linear-gradient(to right, #ec4899, #a855f7)",
              ],
              transition: { duration: 1.5, repeat: Infinity },
            }}
          >
            {/* Pink shimmer effect */}
            <motion.div
              className="absolute inset-0 bg-white opacity-0 hover:opacity-20"
              animate={{
                x: [-100, 300],
                opacity: [0, 0.2, 0],
                transition: {
                  duration: 2,
                  repeat: Infinity,
                  repeatDelay: 3,
                },
              }}
            />

            {/* Text with more pronounced animation */}
            <motion.span
              className="whitespace-nowrap"
              initial={{ x: 0 }}
              animate={{
                x: [0, 5, 0],
                transition: {
                  duration: 1.5,
                  repeat: Infinity,
                  repeatType: "reverse",
                },
              }}
              whileHover={{
                scale: 1.1,
                transition: { type: "spring", stiffness: 500 },
              }}
            >
              Book a Free Demo
            </motion.span>

            {/* Animated calendar icon with pink accent */}
            <motion.div
              animate={{
                rotate: [0, 10, -10, 0],
                y: [0, -3, 0],
                transition: {
                  duration: 2,
                  repeat: Infinity,
                  repeatType: "mirror",
                },
              }}
              whileHover={{
                scale: 1.2,
                rotate: 360,
                transition: { duration: 0.5 },
              }}
            >
              <Calendar className="h-5 w-5 text-pink-200" />
            </motion.div>

            {/* Sparkle dots */}
            <motion.div
              className="absolute -top-1 -right-1 w-3 h-3 bg-white rounded-full shadow-sm"
              animate={{
                scale: [1, 1.5, 1],
                opacity: [0.8, 1, 0],
                transition: {
                  duration: 1.5,
                  repeat: Infinity,
                  delay: 0.7,
                },
              }}
            />
            <motion.div
              className="absolute -bottom-1 -left-1 w-2 h-2 bg-yellow-300 rounded-full shadow-sm"
              animate={{
                y: [0, -4, 0],
                opacity: [0.6, 1, 0.6],
                transition: {
                  duration: 2,
                  repeat: Infinity,
                },
              }}
            />
          </motion.a>
        </motion.div>
      </div>
      
      {/* <div className='fixed bottom-10 right-10 !z-[9999] group'>
             <a
              href="#contact"
           
              className="relative  bg-gradient-to-r from-blue-600 transition-all duration-500 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white px-4 py-2 rounded-lg font-semibold flex items-center justify-center gap-2 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <span className='group-hover:block hidden transition-all duration-500'>
              Book a Free Demo
              </span>
              <Calendar  className="transition-transform group-hover:translate-x-1" />
            </a>
            </div> */}
      {/* Decorative elements */}
      <img
        src={Stripe}
        alt="stripe"
        className="absolute top-0 left-1/2 transform -translate-x-1/2 w-1/2 max-w-[600px] z-0"
      />
      
      <div className="relative z-10 container mx-auto px-6 md:px-12 lg:px-18 py-20 md:py-20 flex flex-col lg:flex-row items-center justify-between gap-12">
        
        {/* Text Content - always comes first in DOM for better mobile flow */}
        <div className="text-center lg:text-left lg:max-w-[50%] w-full">
      
                    <div className="flex flex-col sm:flex-row gap-4 md:mt-10 justify-center lg:justify-start  lg:mt-10">
            <button
              onClick={handleLogin}
              className="relative bg-gradient-to-r animate-pulse from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white px-4 py-2 rounded-lg font-semibold flex items-center justify-center gap-2 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              Login Here
              <FaArrowRight className="transition-transform group-hover:translate-x-1" />
            </button>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 leading-tight lg:mt-5 lg:mb-10">
            Revolutionize Your Examination Experience with{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
              QCBT
            </span>
          </h1>
              <div className="inline-block px-4 py-2 bg-blue-100 text-blue-600 border border-blue-200 rounded-full text-sm font-medium mb-6 shadow-inner">
            🚀 Next Generation Exam Platform
          </div>

          <p className="mt-4 md:mt-6 text-lg md:text-xl text-gray-600 max-w-2xl mx-auto lg:mx-0">
            Computer Based Test (CBT) Platform Conduct
          </p>

          {/* Features grid */}
          <div className="flex flex-wrap justify-center lg:justify-start gap-3 mt-6 lg:mt-10">
            {[
              { icon: <FaLock className="text-blue-500" />, text: "Secure" },
              {
                icon: <FaExpandAlt className="text-green-500" />,
                text: "Scalable",
              },
              { icon: <FaBrain className="text-purple-500" />, text: "Smart" },
              {
                icon: <FaLaptopCode className="text-indigo-500" />,
                text: "Online Exam Platform",
              },
            ].map((feature, i) => (
              <div
                key={i}
                className="flex items-center gap-2 px-3 py-1 md:px-4 md:py-2 bg-white/80 backdrop-blur-md rounded-full shadow hover:shadow-md transition-all whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                <div>{feature.icon}</div>
                <span className="font-medium text-gray-800">
                  {feature.text}
                </span>
              </div>
            ))}
          </div>

          {/* Buttons */}

        </div>

        {/* Hero Image - moves below on small screens */}
        <div className="relative w-full lg:w-1/2 flex justify-center">
          <div className="relative z-10 w-fit">
            <img
              src={HeroStudent}
              alt="Student using QCBT"
              className="w-[250px] md:w-[300px] lg:w-[350px] mx-auto animate-float"
            />
            {/* Notification Card 1 - Exam Completed */}
            <div className="absolute -bottom-8 right-0 sm:-right-6  bg-white/70 p-3 sm:p-4 rounded-lg shadow-lg border border-gray-100 w-56 sm:w-64 animate-fade-in-up delay-100">
              <div className="flex items-center gap-3">
                <div className="bg-blue-100 p-2 rounded-lg">
                  <svg
                    className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <div>
                  <p className="font-bold text-gray-800 text-sm sm:text-base">
                    Secure Testing
                  </p>
                  <p className="text-xs text-gray-500">
                    Tamperproof system active
                  </p>
                </div>
              </div>
            </div>

            {/* Notification Card 2 - New Message */}
            <div className="absolute top-[40%] -left-8 sm:-left-28 bg-white/70 p-3 sm:p-4 rounded-lg shadow-lg border border-gray-100 w-56 sm:w-64 animate-fade-in-up delay-300">
              <div className="flex items-center gap-3">
                <div className="bg-green-100 p-2 rounded-lg">
                  <svg
                    className="w-5 h-5 sm:w-6 sm:h-6 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                    />
                  </svg>
                </div>
                <div>
                  <p className="font-bold text-gray-800 text-sm sm:text-base">
                    Exam Completed
                  </p>
                  <p className="text-xs text-gray-500">Results available now</p>
                </div>
              </div>
            </div>

            {/* Notification Card 3 - Performance Improved */}
            <div className="absolute top-[60%] right-0 sm:-right-20 bg-white/70 p-3 sm:p-4 rounded-lg shadow-lg border border-gray-100 w-56 sm:w-64 animate-fade-in-up delay-500">
              <div className="flex items-center gap-3">
                <div className="bg-purple-100 p-2 rounded-lg">
                  <svg
                    className="w-5 h-5 sm:w-6 sm:h-6 text-purple-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                    />
                  </svg>
                </div>
                <div>
                  <p className="font-bold text-gray-800 text-sm sm:text-base">
                    Performance
                  </p>
                  <p className="text-xs text-gray-500">
                    Flexible & Customizable
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Terminal Section */}
      {/* <div className="flex justify-center mt-5 mb-10 px-4">
        <div className="bg-gray-900 rounded-xl shadow-lg font-mono w-full max-w-[600px] text-sm text-left">
          <ExamTerminal />
        </div>
      </div> */}
    </section>
  );
};

export default Home;